import React from 'react';
import { cn } from '../lib/utils';

const StatCard = ({ title, value, subtitle, icon: Icon, trend, className }) => {
  return (
    <div 
      className={cn("bg-[#18181b] border border-[#27272a] rounded-lg p-6", className)}
      data-testid="stat-card"
    >
      <div className="flex items-start justify-between mb-4">
        <div>
          <p className="text-xs uppercase tracking-wider font-semibold text-zinc-400" data-testid="stat-title">
            {title}
          </p>
        </div>
        {Icon && (
          <div className="p-2 rounded-lg bg-emerald-500/10">
            <Icon className="w-5 h-5 text-emerald-500" />
          </div>
        )}
      </div>
      <div className="space-y-2">
        <h2 className="text-3xl font-black tracking-tight font-mono" data-testid="stat-value">
          {value}
        </h2>
        {subtitle && (
          <p className="text-sm text-zinc-400" data-testid="stat-subtitle">
            {subtitle}
          </p>
        )}
        {trend && (
          <div className="flex items-center gap-1 text-sm">
            {trend}
          </div>
        )}
      </div>
    </div>
  );
};

export default StatCard;
